import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useSapCtas } from './useSapCtas';

export const SapCtas: React.FC = () => {
	const { actions, data } = useSapCtas();

	return (
		<div className="flex flex-col items-center justify-center gap-5 lg:flex-row">
			<Button
				as="a"
				data-testid="homepage-hero-primary-cta"
				data-qa="homepage-hero-primary-cta"
				href={data.primaryCtaUrl}
				variant="primary-strong"
				className="max-w-full self-stretch lg:self-auto"
				onClick={actions.onPrimaryCtaClick}
			>
				<Translate value="corgi.homepage.hero_sunrise.primary_button_text" />
			</Button>

			<Button
				as="a"
				data-testid="homepage-hero-secondary-cta"
				data-qa="homepage-hero-secondary-cta"
				href={data.secondaryCtaUrl}
				variant="secondary-solid"
				className="max-w-full self-stretch lg:self-auto"
				onClick={actions.onSecondaryCtaClick}
			>
				<Translate value="corgi.homepage.hero_sunrise.secondary_button_text" />
			</Button>
		</div>
	);
};
